/* eslint-disable consistent-return */
import axios from 'axios';
import qs from 'qs';

export const getPutPostConfig = (headers = {}) => {
  const returnHeaders = headers;

  // console.log('getPutPostConfig', returnHeaders);

  if (
    !headers.Authorization
    && 'props' in window
    && 'csrfToken' in window.props
  ) {
    returnHeaders['X-CSRF-TOKEN'] = window.props.csrfToken;
  }

  // console.log('getPutPostConfig', returnHeaders);

  return { headers: returnHeaders };
};

const get = async (url, params = {}, headers = {}) => {
  try {
    return await axios.get(url, {
      headers,
      params,
      paramsSerializer: (paramData) => qs.stringify(paramData),
    });
  } catch (error) {
    if (error && error.response && error.response.data) {
      if (error.response.data.message) {
        throw new Error(error.response.data.message, { cause: error });
      }

      throw new Error(error.response.data, { cause: error });
    }

    throw error;
  }
};

const put = async (url, data = null, headers = {}) => {
  try {
    return await axios.put(url, data, getPutPostConfig(headers));
  } catch (error) {
    if (error && error.response && error.response.data) {
      if (error.response.data.message) {
        throw new Error(error.response.data.message, { cause: error });
      }

      throw new Error(error.response.data, { cause: error });
    }

    throw error;
  }
};

const post = async (url, data = null, headers = {}) => {
  try {
    return await axios.post(url, data, getPutPostConfig(headers));
  } catch (error) {
    if (error && error.response && error.response.data) {
      if (error.response.data.message) {
        throw new Error(error.response.data.message, { cause: error });
      }

      throw new Error(error.response.data, { cause: error });
    }

    throw error;
  }
};

const patch = async (url, data = null, headers = {}) => {
  try {
    return await axios.patch(url, data, getPutPostConfig(headers));
  } catch (error) {
    if (error && error.response && error.response.data) {
      if (error.response.data.message) {
        throw new Error(error.response.data.message, { cause: error });
      }

      throw new Error(error.response.data, { cause: error });
    }

    throw error;
  }
};

const destroy = async (url, params = null, headers = {}) => {
  try {
    const config = getPutPostConfig(headers);
    config.params = params;

    return await axios.delete(url, config);
  } catch (error) {
    if (error && error.response && error.response.data) {
      if (error.response.data.message) {
        throw new Error(error.response.data.message, { cause: error });
      }

      throw new Error(error.response.data, { cause: error });
    }

    throw error;
  }
};

const ResourceApi = {
  get, put, post, patch, destroy,
};

export default ResourceApi;
